import axios from "axios";
import { LOGINURL } from "../config";
import { getToken, removeToken } from "../utils/auth";

const baseUrl = process.env.REACT_APP_BACKEND_URL;

const restService = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export const formDataPostService = (apiUrl, payload) => {
  return axios.post(
    `${baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`}${apiUrl}`,
    payload,
    {
      headers: {
        accept: "application/json, text/plain, */*",
        "access-control-allow-origin": "*",
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

const restAuthService = (token = getToken()) => {
  const instance = axios.create({
    baseURL: baseUrl,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  });
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (
        (error?.response?.data === "User login not found" &&
          error?.response?.status === 403) ||
        (error?.response?.status === 401 &&
          error?.response?.data?.title === "Unauthorized")
      ) {
        localStorage.setItem(
          "sessionTimeout",
          "Your session has expired. Please login again."
        );
        removeToken();
        window.location.href = LOGINURL;
      } else {
        if (
          error.response &&
          error.response.status >= 400 &&
          error.response.status <= 500
        ) {
          // this will trigger the `handleError` function in the promise chain
          return Promise.reject(error);
        }
      }
    }
  );
  return instance;
};

export const getAuthMethod = (apiUrl, token) => {
  return restAuthService(token).get(apiUrl);
};

export const postAuthMethod = (apiUrl, data, params) => {
  return restAuthService().post(apiUrl, data, params);
};

export const putAuthMethod = (apiUrl, id, data, params) => {
  return restAuthService().put(`${apiUrl}/${id}`, data, params);
};

export const patchAuthMethod = (apiUrl, id, data, params) => {
  return restAuthService().patch(`${apiUrl}/${id}`, data, params);
};

export const deleteAuthMethod = (apiUrl) => {
  return restAuthService().delete(`${apiUrl}`);
};

export const getMethod = (apiUrl) => {
  return restService.get(apiUrl);
};

export const postMethod = (apiUrl, data) => {
  return restService.post(apiUrl, data);
};

export const putMethod = (apiUrl, id, data, params) => {
  return restService.put(`${apiUrl}/${id}`, data, params);
};

export const deleteMethod = (apiUrl) => {
  return restService.delete(`${apiUrl}`);
};
